import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl } from '../../../../../../Containers/Config/index.js';
import { GET_UPLOAD_SURGE_TYPE, GET_UPLOAD_SURGE_TYPE_SUCCESS, GET_UPLOAD_SURGE_TYPE_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* getUploadSurgeType({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };

    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v1/admin/data-integration/upload-types`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: GET_UPLOAD_SURGE_TYPE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: GET_UPLOAD_SURGE_TYPE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_UPLOAD_SURGE_TYPE_ERROR, payload: error });
  }
}

export function* watchgetUploadSurgeType() {
  yield takeEvery(GET_UPLOAD_SURGE_TYPE, getUploadSurgeType);
}

function* getUploadSurgeTypeSaga() {
  yield all([fork(watchgetUploadSurgeType)]);
}

export default getUploadSurgeTypeSaga;
